const ChevronRightIcon = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="18.707" viewBox="0 0 10.061 18.707">
            <path
                id="Path_3497"
                data-name="Path 3497"
                d="M0,0,9,9l9-9"
                transform="translate(0.354 18.354) rotate(-90)"
                fill="none"
                stroke="currentcolor"
                strokeWidth="1"
            />
        </svg>
    );
};

export default ChevronRightIcon;
